import { Anchor, Box, Button, CheckBox, FileInput, FormField, Grid, ResponsiveContext, Select, Text, TextArea, TextInput } from "grommet";
import * as React from "react";
import AutoSizeTextArea from "../components/AutoSizeTextArea";
import BadgeLogoPicker from "./BadgeLogoPicker";
import { BadgeViewModel } from "./BadgeStore";

const BadgeDetails = ({ badge, isBusy, onChange }: { badge: BadgeViewModel; isBusy: boolean; onChange: Function }) => {
    const [name, setName] = React.useState(badge.name || "");
    const [description, setDescription] = React.useState(badge.description || "");

    const [logoUri, setLogoUri] = React.useState(badge.logoURI || "");

    const [isParticipationBadge, setIsParticipationBadge] = React.useState(badge.isParticipationBadge || false);

    const [logoContent, setLogoContent] = React.useState("");

    React.useEffect(() => {
        onChange({ description, name, logoUri, logoContent, isParticipationBadge });
    }, [description, name, logoUri, logoContent, isParticipationBadge]);

    const size = React.useContext(ResponsiveContext);

    React.useEffect(() => {
        if (badge.logoURI && logoUri != badge.logoURI) {
            setLogoUri(badge.logoURI);
        }
    }, [badge.logoURI]);

    const handleLogoChange = ({ uri, content }) => {
        if (content) {
            setLogoContent(content);
            setLogoUri("");
        } else if (uri) {
            setLogoUri(uri);
            setLogoContent("");
        }
    };

    return (
        <div>
            <>
                <Grid columns={["auto"]} gap="small">
                    <CheckBox label="Participation" checked={isParticipationBadge} onChange={(e) => setIsParticipationBadge(e.target.checked)} disabled={isBusy} />

                    <FormField label="Badge Name">
                        <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isBusy} />
                    </FormField>

                    <FormField label="Description">
                        <AutoSizeTextArea value={description} onChange={(e) => setDescription(e.target.value)} disabled={isBusy} />
                    </FormField>

                    <Box fill={true}>
                        <BadgeLogoPicker uri={logoUri} disabled={isBusy} onSelect={handleLogoChange}></BadgeLogoPicker>
                    </Box>
                </Grid>
            </>
        </div>
    );
};

export default BadgeDetails;
